import { SpriteGenderNames } from "../Enums/NameEnums";

export function getSpriteByGenber(obj: { spriteM: string, spriteF: string }, gender: SpriteGenderNames) {
    return gender === SpriteGenderNames.M ? obj.spriteM : obj.spriteF;
}

export function randomEnum<T>(anEnum: T): T[keyof T] {
    const index = Math.floor(Math.random() * Object.keys(anEnum).length);
    return Object.values(anEnum)[index];
}

export function returnRandomElementOfArray(arr: any[]) {
    const randomNumber = Math.floor(Math.random() * arr.length)
    return arr[randomNumber];
}

export function shuffleArray(array: any[]) {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
}

export function percentage(partialValue, totalValue) {
    return (100 * partialValue) / totalValue;
 }